/*   no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import IconButton from "@mui/material/IconButton";

function QuickPanelToggler(props) {
  return (
    <>
      <IconButton onClick={props.setter}>
        <AccountBalanceWalletIcon
          id="walletIconHeader"
          style={{ color: "#6c6e86" }}
        />
      </IconButton>
    </>
  );
}

export default QuickPanelToggler;
